// account-context.js
// import React, { createContext, useContext } from 'react';

// const AccountContext = createContext(null);
// export const useAccount = () => {
//   const v = useContext(AccountContext);
//   if (!v) throw new Error('useAccount must be used within <AccountProvider>');
//   return v;
// };

// export function AccountProvider({ accountId, children }) {
//   return <AccountContext.Provider value={{ accountId }}>{children}</AccountContext.Provider>;
// }

import React, { createContext, useContext, useMemo } from "react";

const AccountContext = createContext(null);

export const useAccount = () => {
  const ctx = useContext(AccountContext);
  if (!ctx) throw new Error("useAccount must be used within <AccountProvider>");
  return ctx;
};

/**
 * Props:
 * - accountId: number | null
 * - userEmail: string | null
 * - language: string
 * - setLanguage: (lng: string) => void
 * - Any other globals you want to expose (messages, setMessages, etc.)
 */
export function AccountProvider({
  accountId,
  userEmail,
  language = "en",
  setLanguage,
  children,
}) {
  // Avoid unnecessary re-renders of consumers
  const value = useMemo(
    () => ({ accountId, userEmail, language, setLanguage }),
    [accountId, userEmail, language, setLanguage]
  );

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>;
}